/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Mode_NowInputs */

const vi_irrigation_run_mode_now = /** @type {(inputs: Irrigation_Run_Mode_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tưới ngay`)
};

/**

* @param {Irrigation_Run_Mode_NowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_mode_now = /** @type {((inputs?: Irrigation_Run_Mode_NowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Mode_NowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_mode_now(inputs)
});